import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './context/LanguageContext';
import './App.css';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Committee from './pages/Committee';
import Members from './pages/Members';
import Events from './pages/Events';
import Gallery from './pages/Gallery';
import Blogs from './pages/Blogs';
import PastEvent from './pages/PastEvent';
import Sponsors from './pages/Sponsors';
import SEO from './components/SEO';

// Firebase Auth Providers & Pages
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Signup from './pages/Signup';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <LanguageProvider>
          <AuthProvider>
            <div className="App">
              <SEO />
              <ScrollToTop />
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/committee" element={<Committee />} />
              <Route path="/members" element={<Members />} />
              <Route path="/events" element={<Events />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/sponsors" element={<Sponsors />} />
              <Route path="/past-event/:id" element={<PastEvent />} />
              
              {/* Auth Routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              
              {/* Admin Portal Base Route */}
              <Route path="/admin-login" element={<AdminLogin />} />
              
              {/* Secure Admin Dashboard Route */}
              <Route 
                path="/admin/dashboard" 
                element={
                  <ProtectedRoute requireAdmin={true}>
                    <AdminDashboard />
                  </ProtectedRoute>
                } 
              />
            </Routes>
            <Footer />
          </div>
        </AuthProvider>
      </LanguageProvider>
    </Router>
    </HelmetProvider>
  );
}

export default App;
